import React, { useState, useEffect } from "react";
import MainCalculatorsList from "../FoodCalculator/MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Kalkulator Pancake Sempurna - Cara Membuat Pancake Renyah dan Lembut";
const DESCRIPTION =
  "Kalkulator pancake sempurna gratis - hitung jumlah bahan yang tepat untuk membuat pancake yang lembut dan lezat. Masukkan jumlah pancake atau ukurannya dan dapatkan resep pancake sempurna secara instan.";
const KEYWORDS =
  "kalkulator pancake, cara membuat pancake, bahan pancake, kalkulator resep makanan, pancake lembut, bahan-bahan pancake, pancake calculator, perfect pancake recipe";
const OG_URL = "https://do-calculate.com/calculator/id/perfect-pancake/";

const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "Kalkulator Pancake Sempurna",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Beranda",
        item: "https://do-calculate.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Kalkulator",
        item: "https://do-calculate.com/id/all-calculators/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Kalkulator Pancake Sempurna",
        item: OG_URL,
      },
    ],
  },
];

function PerfectPancakeCalculator() {
  // --- States ---
  const [pancakeCount, setPancakeCount] = useState(8);
  const [pancakeSize, setPancakeSize] = useState(10); // Diameter in cm
  const [pancakeThickness, setPancakeThickness] = useState(1); // cm
  const [servingSize, setServingSize] = useState(2); // Pancakes per person

  const [result, setResult] = useState(null);

  // --- Calculations ---
  const calculateIngredients = () => {
    const radius = pancakeSize / 2;
    const volumePerPancake = Math.PI * Math.pow(radius, 2) * pancakeThickness;

    const referenceVolume = Math.PI * Math.pow(5, 2) * 1;
    const scaleFactor = (volumePerPancake / referenceVolume) * pancakeCount;

    const flour = 62.5 * scaleFactor;
    const milk = 90 * scaleFactor;
    const eggs = 0.5 * scaleFactor;
    const butter = 7.5 * scaleFactor;
    const sugar = 5 * scaleFactor;
    const bakingPowder = 3 * scaleFactor;
    const salt = 0.5 * scaleFactor;

    setResult({
      flour,
      milk,
      eggs: Math.ceil(eggs * 10) / 10,
      butter,
      sugar,
      bakingPowder,
      salt,
      totalVolume: volumePerPancake * pancakeCount,
      peopleServed: Math.floor(pancakeCount / servingSize)
    });
  };

  useEffect(() => {
    calculateIngredients();
  }, [pancakeCount, pancakeSize, pancakeThickness, servingSize]);

  const handleClear = () => {
    setPancakeCount(8);
    setPancakeSize(10);
    setPancakeThickness(1);
    setServingSize(2);
    setResult(null);
  };

  return (
    <div className="ltr" style={{ direction: "ltr" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={SCHEMA}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "5px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>Kalkulator Pancake Sempurna</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>Kalkulator Pancake Sempurna</strong> membantu Anda menentukan takaran bahan yang tepat untuk membuat pancake sempurna berdasarkan jumlah dan ukuran pancake yang ingin Anda buat. Baik Anda menyiapkan sarapan untuk dua orang atau pesta keluarga, alat ini memastikan keseimbangan sempurna antara tepung, susu, dan telur.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />

            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>Tentukan Detail Pancake Anda</h2>
              </div>

              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <label>Jumlah Pancake yang Diinginkan</label>
                  <input
                    type="number"
                    className="form-control"
                    value={pancakeCount}
                    onChange={(e) => setPancakeCount(parseFloat(e.target.value) || 0)}
                    min="1"
                  />
                </div>
                <div className="col-sm-12 col-md-6">
                  <label>Diameter Pancake (cm)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={pancakeSize}
                    onChange={(e) => setPancakeSize(parseFloat(e.target.value) || 0)}
                    min="1"
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-sm-12 col-md-6">
                  <label>Ketebalan Pancake (cm)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={pancakeThickness}
                    onChange={(e) => setPancakeThickness(parseFloat(e.target.value) || 0)}
                    min="0.1"
                    step="0.1"
                  />
                </div>
                <div className="col-sm-12 col-md-6">
                  <label>Berapa Pancake per Orang?</label>
                  <input
                    type="number"
                    className="form-control"
                    value={servingSize}
                    onChange={(e) => setServingSize(parseFloat(e.target.value) || 1)}
                    min="1"
                  />
                </div>
              </div>

              <div className="text-center mb-3 mt-4">
                <button
                  onClick={handleClear}
                  className="btn btn-secondary"
                  style={{ fontSize: "16px", padding: "10px 30px" }}
                >
                  Reset
                </button>
              </div>

              {result && (
                <div className="mt-4">
                  <h3 style={{ fontSize: "18px", marginBottom: "15px", textAlign: "center" }}>
                    <strong>Bahan yang Diperlukan:</strong>
                  </h3>
                  <div className="mb-3">
                    <table className="table bmi-table" style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th className="bmi-header" style={{ textAlign: "center" }}>Bahan</th>
                          <th className="bmi-header" style={{ textAlign: "center" }}>Jumlah</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ textAlign: "center" }}>Tepung Terigu</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.flour.toFixed(1)} gram</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Susu</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.milk.toFixed(1)} ml</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Telur</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.eggs} butir</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Mentega Cair</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.butter.toFixed(1)} gram</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Gula</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.sugar.toFixed(1)} gram</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Baking Powder</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.bakingPowder.toFixed(1)} gram</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Garam</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.salt.toFixed(1)} gram</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="info-sections-container">
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>Ringkasan Sajian</strong>
                      </div>
                      <div className="info-section-body">
                        <ul style={{ listStyle: "none", padding: 0, lineHeight: "2" }}>
                          <li>🥞 <strong>Total Pancake:</strong> {pancakeCount} pancake</li>
                          <li>👥 <strong>Cukup untuk:</strong> sekitar {result.peopleServed} orang</li>
                          <li>🥣 <strong>Total Volume Adonan:</strong> {result.totalVolume.toFixed(0)} ml</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>

      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>Rahasia Pancake Sempurna</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Untuk mendapatkan hasil terbaik dengan bahan-bahan yang ditampilkan kalkulator, ikuti tips berikut:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Jangan terlalu banyak mengaduk:</strong> Aduk bahan hanya sampai gumpalan besar hilang; pengadukan berlebihan membuat pancake menjadi keras.</li>
                  <li><strong>Istirahatkan adonan:</strong> Biarkan adonan beristirahat 5-10 menit sebelum dimasak untuk mengaktifkan baking powder.</li>
                  <li><strong>Suhu wajan:</strong> Gunakan wajan anti lengket di atas api sedang.</li>
                  <li><strong>Tanda kematangan:</strong> Balik pancake ketika muncul gelembung di permukaan dan tepinya terlihat sedikit kering.</li>
                </ul>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <strong>Cara Kerja Kalkulator Pancake</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Kalkulator ini menggunakan rumus matematika berdasarkan volume pancake (diameter dan ketebalan) untuk memperkirakan jumlah adonan cair yang dibutuhkan. Kemudian membagi volume tersebut menjadi persentase bahan kering dan cair yang tepat berdasarkan standar chef internasional untuk tekstur terbaik yang lembut.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PerfectPancakeCalculator;